<template>
  <div class="paySuccess-content">
    <div class="content-bg">
      <div class="content-text">
        <img src="https://resource.rcclchina.com.cn/paySuccess/success-pcIcon.png" alt="">
        <div>
          <p>感谢您预订岸上观光！</p>
          <p>请继续选择皇家行前订产品，提前锁定名额</p>
        </div>
      </div>
      <div class="content-options">
        <div class="con-option" v-for="(item,index) in skipList" :key="index"
             @click="goPcpItem(item.routeUrl,item.modelName)" :style="'left:'+item.leftPixel">
          <img :src="item.imgUrl" alt="">
        </div>
      </div>
      <div class="reserve-btn" @click="goPcp">前往预订</div>
    </div>

    <common-modal :isShow="showShorexSubmitKoreaAlter" :modalWidth="500" type="custom">
      <div class="custom-confirm-box">
<!--        <div class="custom-confirm-title">{{shorexSubmitKoreaAlterTitle}}</div>-->
        <div class="custom-confirm-content">
          <div class="inner-html" v-html="shorexSubmitKoreaAlterContent"></div>
        </div>
        <div class="custom-confirm-footer">
          <div class="btn" @click="shorexSubmitKoreaAlterClose">已知悉</div>
        </div>
      </div>
    </common-modal>
  </div>
</template>
<script>
import api from "@/api";
import {gioTracking} from "@/utilities/tools";
const CommonModal = () => import("@/components/Common/CommonModal");

export default {
  components: {
    CommonModal
  },
  data(){
    return{
      skipList:[
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/wifi-pc-2026.png',routeUrl:'/Rccl.PCP/product/Wifi',leftPixel:'0',modelName:'pcpUpsellWifi'},
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/dining-pc-2026.png',routeUrl:'/Rccl.PCP/product/dining',leftPixel:'150px',modelName:'pcpUpsellFood'},
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/activity-pc-2026.png',routeUrl:'/Rccl.PCP/product/activity',leftPixel:'300px',modelName:'pcpUpsellEvent'},
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/serve-pc-2026.png',routeUrl:'/Rccl.PCP/product/service',leftPixel:'450px',modelName:'pcpUpsellService'}
      ],
      token:'',
      showShorexSubmitKoreaAlter: false,
      shorexSubmitKoreaAlterTitle: "",
      shorexSubmitKoreaAlterContent: ""
    }
  },
  async beforeMount() {
    this.getToken()
    const isShowPopup = this.$route.query.isShowPopup;
    if (isShowPopup === 'true' || isShowPopup === true) {
      await this.getShorexSubmitKoreaAlter();
    }
  },
  methods:{
    async getToken() {
      const {data} = await api.user.getPcpToken()
      if (data && data.length > 0) {
        this.token = data
      }
    },
    goPcpItem(url,name){
      console.log(name)
      gioTracking('track','evt_ButtonClicked',{'btnTypes':name})
      location.href=process.env.VUE_APP_PCP_URL + url+`?token=${this.token}&hmsr=rcclchinapc&hmpl=paidupsell&hmcu=pcp&hmci=internet&hmkw=`
    },
    goPcp() {
      gioTracking('track','evt_ButtonClicked',{'btnTypes':'pcpUpsellBook'})
      location.href = process.env.VUE_APP_PCP_URL + `/Rccl.Pcp/Home/Index?token=${this.token}&hmsr=rcclchinapc&hmpl=paidupsell&hmcu=pcp&hmci=hp&hmkw=`
    },
    async getShorexSubmitKoreaAlter() {
      const {success, data} = await api.page.getContentByKey({
        key: 'SHOREX_SUBMIT_KOREA_ALTER'
      })
      if (success && data) {
        if(data) {
          this.showShorexSubmitKoreaAlter = true;
          this.shorexSubmitKoreaAlterTitle = data.title;
          this.shorexSubmitKoreaAlterContent = data.content;
        }
      }
    },
    shorexSubmitKoreaAlterClose() {
      this.showShorexSubmitKoreaAlter = false;
      this.shorexSubmitKoreaAlterTitle = "";
      this.shorexSubmitKoreaAlterContent = "";
    }
  }
}
</script>
<style lang="less" scoped>
.paySuccess-content{
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  background: #f2f6f9;
  & .content-bg{
    width: 1200px;
    height: 605px;
    background: url("https://resource.rcclchina.com.cn/paySuccess/pcSuccess-bg.png") no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    padding-top: 128px;
  }
  & .content-text{
    color: #fff;
    display: flex;
    align-items: center;
    gap: 24px;
    font-size: 20px;
    padding-left: 128px;
    & img{
      height: 73px;
      width: 73px;
    }
    & p{
      margin: 0;
    }
    & p:first-child{
      font-size: 36px;
    }
  }
  & .content-options{
    margin-top: 44px;
    margin-left: 41px;
    display: flex;
    position: relative;
    width: 100%;
    height: 154px;
    & .con-option{
      width: 165px;
      height: 154px;
      position: absolute;
      top: 0;
      cursor: pointer;
      & img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .reserve-btn{
    width: 325px;
    height: 50px;
    margin-left: 195px;
    text-align: center;
    margin-top: 54px;
    border-radius: 25px;
    font-size: 24px;
    font-weight: 500;
    color: #000;
    line-height: 50px;
    background: linear-gradient(-139deg,#ffdb17,#fcbf00);
    cursor: pointer;
  }
}

.custom-confirm-box {
  border-radius: 5px;
  background-color: #fff;
}
.custom-confirm-title {
  padding: 15px 0 9px;
  margin: 0 17px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  border-bottom: 1px solid #eee;
  color: #000000;
}
.custom-confirm-content {
  font-size: 14px;
  padding: 20px 30px;
  & .inner-html {
    & p {
      font-size: 12px;
      color: #5e5e5e;
      margin-bottom: 0;
      margin-top: 4px;
    }
  }
}
.custom-confirm-footer {
  padding: 0 15px 15px;
}
.custom-confirm-footer .btn {
  display: block;
  margin: 0 auto;
  padding: 0 20px;
  width: 200px;
  line-height: 44px;
  height: 44px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #333;
  background:linear-gradient(225deg,rgba(255,219,23,1) 0%,rgba(252,191,0,1) 100%);
  border-radius: 5px;
}
</style>
<style lang="less">
.custom-confirm-content {
  max-height: 50vh;
  overflow-x: hidden;
  overflow-y: auto;
  & .inner-html {
    & p {
      font-size: 13px;
      color: #333;
      margin-bottom: 0;
      margin-top: 4px;
      &:first-child {
        margin-top: 0;
      }
    }
    & img {
      max-width: 100% !important;
    }
  }
}
</style>